import { createStore, ModuleTree } from "vuex";
import storeAppsModulesConfig from "../../modules-config.json";
import { StoreAppModule, StoreState } from "./type";

// Use Vite's import.meta.glob instead of require.context
const moduleFiles = import.meta.glob("@/modules/*/vuex/index.ts", {
  eager: true,
});
const availableModules: Record<string, any> = {};
const storeModules: ModuleTree<StoreState> = {};
const enabledModulesNames: string[] = (
  import.meta.env.VITE_APP_MODULES ?? ""
).split(",");
const enabledModulesConfig = (
  storeAppsModulesConfig as StoreAppModule[]
).filter(
  (module) => enabledModulesNames.includes(module.name) || module.isBase,
);

// Process the modules using Vite's glob
Object.keys(moduleFiles).forEach((filePath) => {
  const moduleName = filePath.split("/")[3]; // Extract module name from path

  if (
    moduleFiles[filePath] &&
    typeof moduleFiles[filePath] === "object" &&
    "default" in moduleFiles[filePath]
  ) {
    availableModules[moduleName] = (moduleFiles[filePath] as any).default;
  }
});

for (const module of enabledModulesConfig) {
  const moduleKey = module.key;
  const storeKey = module.storeKey;

  if (availableModules[moduleKey] && storeKey) {
    storeModules[storeKey] = availableModules[moduleKey];
  }
}

const store = createStore<StoreState>({
  modules: storeModules,
});

export default store;
